import React from "react";
import { Route, Routes, BrowserRouter as Router } from "react-router-dom";
import { AuthProvider } from "./auth";
import PrivateRoute from "./components/PrivateRoutes";
import PublicRoutes from "./components/PublicRoutes";
import ScrollToTop from "./components/ScrollToTop";
import HomePage from "./containers/Home";
import ProductPage from "./containers/Home/Products";
import ServicePage from "./containers/Home/Services";
import PolicyPage from "./containers/Home/Policy";
import PrivacyPolicyPage from "./containers/Home/PrivacyPolicy";
import TermsOfServicePage from "./containers/Home/TermsOfService";
import SupportPage from "./containers/Home/Support";
import WhatsAppButton from "./components/Common/WhatsAppButton/WhatsAppButton";

const AppRouter: React.FC = () => {
  return (
    <AuthProvider>
      <Router>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/products" element={<ProductPage />} />
          <Route path="/services/:id" element={<ServicePage />} />
          <Route path="/policy" element={<PolicyPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
          <Route path="/terms-of-service" element={<TermsOfServicePage />} />
          <Route path="/support" element={<SupportPage />} />
        </Routes>
        <PublicRoutes />
        <PrivateRoute />
        <WhatsAppButton />
      </Router>
    </AuthProvider>
  );
};
export default AppRouter;
